<template>
  <div class="div-container">

    <a href="javascript:void(0)" rel="external nofollow" @click="goMovieDetail">
      <el-card :body-style="{ padding: '0px' ,borderRadius:'20px'}">

        <div class="div-image-container">

          <el-image style="width: 100%; height: 100%" :src="cover_image" fit="cover" class="blur">
          </el-image>

          <div class="cover">
            <el-image style="width: 90%; height: 90%;margin-top: 3%" :src="cover_image" fit="contain">
            </el-image>
          </div>

        </div>

        <div class="div-info-container">

          <div style="float: left;">
            <div style="height: 30px">

            <span style="font-size: 22px;">

              {{data.movie_name}}
            </span>

              <span style="font-size: 14px;">
              {{data.years}}
            </span>

            </div>

            <div style="font-size: 12px;height: 16px;margin: 5px 0 0 1px">

              {{data.english_name}}
            </div>

            <div style="font-size: 12px;height: 16px;margin: 20px 0 0 1px">
              <!--            Batman/Batman/Batman/Batman/Batman-->
            </div>

          </div>

          <div style="float: right;font-size: 80px;font-family: agency">

            {{data.imdb}}
          </div>

        </div>

      </el-card>
    </a>

  </div>
</template>

<script>
import Common from '../../../../js/Common'

export default {
  name: 'MovieItem',
  props: {
    data: Object
  },
  data () {
    return {
      cover_image: Common.getMovieCover(this.data.id)
    }
  },
  methods: {
    goMovieDetail () {
      this.$router.push({path: '/movie/movie_info', name: 'MovieInfo', query: {movie_id: this.data.id}})
    }
  }
}
</script>

<style scoped>
.div-container{
  width:450px;
  height: 380px;
}

.div-image-container{
  position: relative;
  /*width:450px;*/
  height:247px;
  overflow-y: hidden;
  overflow-x: hidden;
}

.blur{
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  width:100%;
  height: 100%;
  object-fit:cover;
  -webkit-filter: blur(10px); /* Chrome, Opera */
}

.cover{
  width:100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  position: absolute;
}

.div-info-container{
  /*width:450px;*/
  height: 93px;
  padding: 20px;
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/MovieItem.vue